import React, { memo } from 'react';

import PropTypes from 'prop-types';

import { FieldTypesEnum } from 'constants/loanActionEditor';

import { DynamicValueInput } from './LoanActionItems';

const LoanActionSubmitUcdRow = ({ index, rootPath, isDisabled, isEditAllowed, options }) => {
  const fieldPath = `${rootPath}[${index}]`;

  return (
    <div>
      <DynamicValueInput
        required
        disabled={isDisabled || !isEditAllowed}
        label="UCD Type"
        name={`${fieldPath}.runUcdSubmitType`}
        options={options}
        type={FieldTypesEnum.SELECT}
      />
    </div>
  );
};

LoanActionSubmitUcdRow.propTypes = {
  rootPath: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  options: PropTypes.array.isRequired,
  isEditAllowed: PropTypes.bool.isRequired,
};

export default memo(LoanActionSubmitUcdRow);
